import { render, staticRenderFns } from "./ActivityWsSpeechBubbles.vue?vue&type=template&id=036931fe&scoped=true"
import script from "./ActivityWsSpeechBubbles.vue?vue&type=script&lang=ts"
export * from "./ActivityWsSpeechBubbles.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsSpeechBubbles.vue?vue&type=style&index=0&id=036931fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036931fe",
  null
  
)

export default component.exports